export default __webpack_public_path__ + "static/media/HeaderLogo.bd6e166e.svg";